import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

const Modal = ({ handleClick, closeOnOutsideClick = true, children }) => {
  function useOutsideClick() {
    function outsideClickHandler(event) {
      if (closeOnOutsideClick && event.target.classList.contains('modal')) {
        handleClick(event);
      }
    }
    function handleClosingClick(event) {
      if (event.keyCode === 27 && closeOnOutsideClick) handleClick(event);
    }
    useEffect(() => {
      document.addEventListener('mousedown', outsideClickHandler);
      document.addEventListener('keydown', handleClosingClick);
      return () => {
        document.removeEventListener('keydown', handleClosingClick);
        document.removeEventListener('mousedown', outsideClickHandler);
      };
    });
  }
  useOutsideClick();
  return <div className="modal-global-container">{children}</div>;
};

Modal.propTypes = {
  handleClick: PropTypes.func.isRequired,
  closeOnOutsideClick: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default Modal;



// WEBPACK FOOTER //
// ./src/features/shared-components/Modal/Modal.js